import React from 'react';
import styled from 'styled-components';

import { VIEWS_TYPES } from '../colorPickerUtils';
import {  InputWrapper } from './InputWrapper';
import { CurrentColorUnit } from './CurrentColorUnit';
import { HexInput } from './HexInput';

const ColorInputBoxWrapper = styled.div`
  width: 100%;
`;

export const HexView = ({ onChange, value }) => {
  return (
    <ColorInputBoxWrapper>
      <InputWrapper>
        <HexInput value={value} onChange={onChange} />
        <CurrentColorUnit>{VIEWS_TYPES.HEX}</CurrentColorUnit>
      </InputWrapper>
    </ColorInputBoxWrapper>
  );
};
